import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { FmlmSearchStepDeclaration } from "../Common/Search/Steps/FmlmSearchStep";
import { JourneyPlannerInitStepDeclaration } from "./Steps/JourneyPlannerInitStep";
import { JourneyPlannerTransition } from "./Transition/JourneyPlannerTransition";

export const JourneyPlannerStartupFlow = new FlowDefinition("JourneyPlannerFlow");

JourneyPlannerStartupFlow.addStep(JourneyPlannerInitStepDeclaration)
JourneyPlannerStartupFlow.addStep(FmlmSearchStepDeclaration);

JourneyPlannerStartupFlow.addLink("JourneyPlannerInit_Step", "FmlmSearchStep");
JourneyPlannerStartupFlow.addLink("FmlmSearchStep", "JourneyPlannerInit_Step");

JourneyPlannerStartupFlow.addTransition(JourneyPlannerTransition, "JourneyPlannerInit_Step");

JourneyPlannerStartupFlow.setStartStep("JourneyPlannerInit_Step");

export const journeyPlannerStartupFlowDefinition = new StepDefinition({
  stepName: "JourneyPlannerFlow",
  stepFlow: JourneyPlannerStartupFlow,
  contextIsolation: false,
});
